import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { Purchase, PurchaseStatus } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useEffect, useState } from 'react'

export const usePurchase = (processId?: string) => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetPurchaseByProcess
    )
    const [purchase, setPurchase] = useState<Purchase | null>(null)
    const [loading, setLoading] = useState<boolean>(false)

    const load = useCallback(async () => {
        if (!processId) return
        setLoading(true)
        try {
            const result = await useCase.execute(processId)
            setPurchase(result ?? null)
        } catch (e: any) {
            // 404 = ainda não existe compra para o processo — estado válido.
            setPurchase(null)
        }
        setLoading(false)
    }, [useCase, processId])

    useEffect(() => {
        load()
    }, [load])

    return { purchase, loading, reload: load }
}
